import { render, staticRenderFns } from "./robotSetup.vue?vue&type=template&id=61b37b51&scoped=true&"
import script from "./robotSetup.vue?vue&type=script&lang=js&"
export * from "./robotSetup.vue?vue&type=script&lang=js&"
import style0 from "./robotSetup.vue?vue&type=style&index=0&id=61b37b51&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b37b51",
  null
  
)

export default component.exports